import React from 'react';
import { Container, Row, Col } from '../../Grid';
import Button from '../../Button';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind({ ...styles });

export const UsedCarEvaluation = ({ openLink, leadtracking }) => (
  <Container>
    <h2 className={styles.headline}>Gebrauchtwagenbewertung</h2>
    <Row>
      <Col cols={12} className={cx('content', 'contentPt')}>
        Hier gelangen Sie zur Gebrauchtwagenbewertung von mazda.de. Die Gebrauchtwagenbewertung von
        mazda.de wird technisch direkt auf der Händlerwebseite dargestellt. Hierbei erteilte
        Zustimmungen für den Einsatz von Cookies und ähnlichen Technologien gelten entsprechend.
      </Col>
    </Row>
    <Row>
      <Col cols={12} className={cx('content', 'contentPt', 'contentPb')}>
        <Button
          label="zur Bewertung"
          target="_blank"
          trackingLabel="Gebrauchtwagenbewertung"
          onClick={openLink}
          additionalProps={leadtracking}
        />
      </Col>
    </Row>
  </Container>
);
